import { createStore, applyMiddleware } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";
import thunk from "redux-thunk";
import Reducers from "./Reducers/Reducers";
import logger from "redux-logger";
const initialState = {};

const middleware = [thunk, logger];

const store = createStore(
	Reducers,
	initialState,
	composeWithDevTools(applyMiddleware(...middleware))
);
//store.subscribe(() => console.log('State: ',store.getState()));

export default store;
